import { ReceptionServiceId } from '@dreryk/egabinet-private-medical-service-published-language-api';

import { EditIcon, Link, RemoveIcon, StyledFlex } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import { ReceptionServiceNameValue } from '../../shared/form/components/ReceptionServiceNameTextInput';
import { ReceptionServiceUpdateModalOpener } from '../../update/ReceptionServiceUpdateModalOpener';
import { ReceptionServiceRemoveConfirmationEventInterceptor } from '../remove/ReceptionServiceRemoveConfirmationEventInterceptor';

import { BoundServiceRemoveAction, ReceptionServiceRemoveAction } from './ReceptionServiceOptionsCell.actions';

type ReceptionServiceUpdateLinkProps = {
   readonly id: ReceptionServiceId;
};

export const ReceptionServiceUpdateLink = (props: ReceptionServiceUpdateLinkProps): JSX.Element => {
   return (
      <ReceptionServiceUpdateModalOpener receptionServiceId={props.id}>
         {({ openModal }) => <Link testId={'receptionServiceUpdate'} icon={<EditIcon />} onClick={openModal} />}
      </ReceptionServiceUpdateModalOpener>
   );
};

type ReceptionServiceRemoveLinkProps = {
   readonly id: ReceptionServiceId;
   readonly name: string;
   readonly hasMorePractitioners: boolean;
};

export const ReceptionServiceRemoveLink = (props: ReceptionServiceRemoveLinkProps): JSX.Element => {
   return (
      <ReceptionServiceRemoveConfirmationEventInterceptor
         receptionServiceName={props.name}
         hasMorePractitioners={props.hasMorePractitioners}
      >
         <ReceptionServiceRemoveAction id={props.id}>
            {({ removeReceptionService }) =>
               protectFeature(
                  'managingPatientPortal',
                  <BoundServiceRemoveAction id={props.id} onSuccess={removeReceptionService}>
                     {({ removeBoundService }) => (
                        <Link testId={'receptionServiceRemove'} onClick={removeBoundService} icon={<RemoveIcon />} />
                     )}
                  </BoundServiceRemoveAction>,
                  <Link testId={'receptionServiceRemove'} onClick={removeReceptionService} icon={<RemoveIcon />} />
               )
            }
         </ReceptionServiceRemoveAction>
      </ReceptionServiceRemoveConfirmationEventInterceptor>
   );
};

type ReceptionServiceOptionsCellProps = {
   readonly id: ReceptionServiceId;
   readonly name: ReceptionServiceNameValue;
   readonly hasMorePractitioners: boolean;
};

export const ReceptionServiceOptionsCell = (props: ReceptionServiceOptionsCellProps): JSX.Element => {
   return (
      <StyledFlex>
         <ReceptionServiceUpdateLink id={props.id} />
         <ReceptionServiceRemoveLink
            id={props.id}
            name={props.name}
            hasMorePractitioners={props.hasMorePractitioners}
         />
      </StyledFlex>
   );
};
